<div class="confirm-dialog">

  <ng-container *ngIf="!success">
    <h3>{{ text }}</h3>
    <app-dict-partners
      *ngIf="enableFilters === null || enableFilters.includes('partner')"
      [multiple]="false" label="Partner"
      class="commission-import-list-filter"
      [(ngModel)]="initialFilters.partner" name="partner"
      [onlyActiveAndNew]="true"
    ></app-dict-partners>
    <app-dict-ofwcas
      *ngIf="enableFilters === null || enableFilters.includes('ofwca')"
      [multiple]="false" label="OFWCA"
      class="commission-import-list-filter"
      [(ngModel)]="initialFilters.ofwca" name="ofwca"
      [statusOfwca]="[OFWCA_STATUS_ACTIVE, OFWCA_STATUS_NEW]"
    ></app-dict-ofwcas>
    <div fxLayout="row" fxLayoutGap="15px">
      <div fxFlex></div>
      <button (click)="confirm()" [class.spinner]="processingRequest"
              [disabled]="processingRequest"
              mat-stroked-button color="primary">
        <mat-icon>save</mat-icon>
        <span> Zapisz</span></button>
      <button (click)="decline()" mat-stroked-button color="warn">
        <mat-icon>cancel</mat-icon>
        <span> Anuluj</span></button>

    </div>
  </ng-container>
  <ng-container *ngIf="success">
    <h3>Kopiowanie zakończone pomyślnie.</h3>
    <ng-container *ngIf="response.newPartner?.shortName">
<!--      http://localhost:8000/aneksy;page=0;pageSize=10;partner=b0a1ad0a-3bcb-48c0-8ec7-e0015f201bb3-->
      <p>Utworzono dla
      <a class="default-link"
         [routerLink]="['/aneksy', {page: 0, pageSize: 10, partner: response.newPartner.uuid}]"
         target="_blank">
        {{ response.newPartner.shortName }}
      </a> (Partner): <b>{{response.countPartner}}</b></p>
    </ng-container>
    <ng-container *ngIf="response.newOfwca?.fullName">
      <p>Utworzono dla
        <a class="default-link"
         [routerLink]="['/aneksy', {page: 0, pageSize: 10, ofwca: response.newOfwca.uuid }]"
         target="_blank">
        {{ response.newOfwca.fullName }}
      </a> (OFWCA): <b>{{response.countOfwca}}</b></p>
    </ng-container>
    <div fxLayout="row" fxLayoutGap="15px">
      <div fxFlex></div>
      <button (click)="close()" mat-stroked-button color="warn">
        <span> Zamknij</span></button>
    </div>
  </ng-container>
</div>
